import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaFacebookF,
  // FaTwitter,
  // FaGoogle,
  FaYoutube,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaInstagram,
} from "react-icons/fa";

const AppFooter = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowTopBtn(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const goTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <footer id="footer">
        <Container>
          <Row>
            {/* Left - Links */}
            <Col md={4} className="text-start ">
              {/* <h3 className="mb-6">Links</h3> */}
              <ul className="list-unstyled">
                <li>
                  <a href="/"> Home</a>
                </li>
                <li>
                  <a href="/academics"> Academics</a>
                </li>
                <li>
                  <a href="/about"> About</a>
                </li>
                <li>
                  <a href="/gallery"> Gallery</a>
                </li>
                <li>
                  <a href="/mandatory"> Mandatory</a>
                </li>
                <li>
                  <a href="/contact"> Contact Us</a>
                </li>
              </ul>
            </Col>

            {/* Center - Social Icons */}
            <Col md={4} className="text-center">
              <h3 className="mb-4">Follow Us</h3>
              <div className="social-icons d-flex justify-content-center flex-wrap">
                {/* <a href="#"><FaWhatsapp /></a> */}
                <a href="https://www.facebook.com/KanchanSchoolRajeevColony/">
                  <FaFacebookF />
                </a>
                <a href="https://www.facebook.com/KanchanSchoolRajeevColony/">
                  <FaInstagram />
                </a>
                {/* <a href="#"><FaGoogle /></a> */}
                <a href="https://www.facebook.com/KanchanSchoolRajeevColony/">
                  <FaYoutube />
                </a>
              </div>
            </Col>

            {/* Right - Contact Info */}
            <Col md={4} className="text-start">
              <h3 className="mb-4">Contact</h3>
              <div className="footer-address">
                <p>
                  <FaEnvelope className="me-2" /> kanchanschool3370@gmail.com
                </p>
                <p>
                  <FaPhone className="me-2" /> +91 98995 60650, 74280 46041
                </p>
                <p>
                  <FaMapMarkerAlt className="me-2" />
                  Sector 56, Rajiv Colony, ballabgarh, Faridabad, Haryana 121004
                </p>
              </div>
            </Col>
          </Row>
        </Container>

        {/* Scroll to Top Button */}
        {showTopBtn && <button className="go-top" onClick={goTop}></button>}
      </footer>
    </>
  );
};

export default AppFooter;
